__turbopack_context__.v({
  "active": "header-module-scss-module__91fkvG__active",
  "activeLink": "header-module-scss-module__91fkvG__activeLink",
  "beta": "header-module-scss-module__91fkvG__beta",
  "burgerButton": "header-module-scss-module__91fkvG__burgerButton",
  "cfrVariant": "header-module-scss-module__91fkvG__cfrVariant",
  "headerContainer": "header-module-scss-module__91fkvG__headerContainer",
  "headerContent": "header-module-scss-module__91fkvG__headerContent",
  "headerScroll": "header-module-scss-module__91fkvG__headerScroll",
  "headerTopRow": "header-module-scss-module__91fkvG__headerTopRow",
  "hideMarketDataBtnWithOpenedSearchMenu": "header-module-scss-module__91fkvG__hideMarketDataBtnWithOpenedSearchMenu",
  "hideSearchOnMobileView": "header-module-scss-module__91fkvG__hideSearchOnMobileView",
  "iconContainer": "header-module-scss-module__91fkvG__iconContainer",
  "iconContainerPremiumization": "header-module-scss-module__91fkvG__iconContainerPremiumization",
  "innerMenuWrapper": "header-module-scss-module__91fkvG__innerMenuWrapper",
  "link": "header-module-scss-module__91fkvG__link",
  "linksButtonsContainer": "header-module-scss-module__91fkvG__linksButtonsContainer",
  "linksWrapper": "header-module-scss-module__91fkvG__linksWrapper",
  "menuOpenedOnMobileView": "header-module-scss-module__91fkvG__menuOpenedOnMobileView",
  "new": "header-module-scss-module__91fkvG__new",
  "panelLink": "header-module-scss-module__91fkvG__panelLink",
  "premiumizationLinksContainer": "header-module-scss-module__91fkvG__premiumizationLinksContainer",
  "searchResultOpenedOnMobileView": "header-module-scss-module__91fkvG__searchResultOpenedOnMobileView",
  "solutionsButton": "header-module-scss-module__91fkvG__solutionsButton",
  "spinner": "header-module-scss-module__91fkvG__spinner",
  "spinnerOverlay": "header-module-scss-module__91fkvG__spinnerOverlay",
  "title": "header-module-scss-module__91fkvG__title",
  "toolbarContainer": "header-module-scss-module__91fkvG__toolbarContainer",
  "transparentBackground": "header-module-scss-module__91fkvG__transparentBackground",
  "userProPlan": "header-module-scss-module__91fkvG__userProPlan",
  "withoutLogin": "header-module-scss-module__91fkvG__withoutLogin",
});
